<template>
	<BaseCmsPage @load="onPageLoad">
		<ClientOnly>
			<BaseWebshopCart v-slot="{cart, parcels, counter}" @removeProduct="removeProduct" @updateProduct="updateProduct">
				<Body class="page-cart" />
				<div class="wrapper">
					<div class="w-row" v-if="parcels?.length">
						<div class="w-col1">
							<div class="continue-shopping" @click="goBack()"><BaseCmsLabel code="continue_shopping" /></div>
							<h1 class="page-title">
								<BaseCmsLabel code="products_in_shopping_cart" /> <span class="counter" v-if="counter">({{ counter }})</span>
							</h1>

							<WebshopErrorMessage :data="parcels" :items="cart?.errors" :warnings="cart?.warnings" />

							<div class="carts" v-if="parcels?.length">
								<div class="cart" v-for="parcel in parcels" :key="parcel.number">
									<div class="cart-title">
										{{ parcel.number }}. <span class="cart-parcel"><BaseCmsLabel code="seller_item_title" />&nbsp;</span>
										<template v-if="parcel.parcel_name">{{ parcel.parcel_name }}</template>
									</div>
									<div class="cart-items">
										<WebshopCartItem v-for="item in parcel.items" :data="item" :parcel="parcel" :key="item.id" />
									</div>
								</div>
							</div>

							<!--
							<BaseCatalogLists :fetch="{code: 'cart_list', single: true}" v-slot="{items}">
								<template v-if="items?.length">
									<div class="cart-sl related" v-for="list in items" :key="list.id">
										<div class="related-title"><BaseCmsLabel code="cart_related_products" /></div>
										<BaseCatalogProductsWidget :fetch="{mode: 'widget', list_code: list.code, sort: 'list_position', only_available: true, limit: 9}" v-slot="{items}">
											<div class="cart-sl-items related-items">
												<BaseUiSwiper
													name="cart-products"
													:options="{
														breakpoints: {
															0: {
																enabled: false
															},
															980: {
																slidesPerView: 2,
																slidesPerGroup: 2,
																enabled: true
															},
															1600: {
																slidesPerView: 4,
																slidesPerGroup: 4,
																enabled: true
															}
														}
													}">
													<BaseUiSwiperSlide v-for="item in items" :key="item.id">
														<CatalogIndexEntry :item="item" mode="cart" />
													</BaseUiSwiperSlide>
												</BaseUiSwiper>
											</div>
										</BaseCatalogProductsWidget>
									</div>
								</template>
							</BaseCatalogLists>
							-->
						</div>

						<div class="w-col2">
							<WebshopSidebar mode="cart" />
							<WebshopWidgetFixedbar mode="cart" />
						</div>
					</div>
					<div class="empty-cart" v-else v-interpolation>
						<BaseCmsLabel code="empty_shopping_cart" tag="div" />
					</div>
				</div>
			</BaseWebshopCart>
		</ClientOnly>
	</BaseCmsPage>
</template>

<script setup>
	const router = useRouter();
	const labels = useLabels();
	const gtm = useGtmBB();
	const webshop = useWebshop();
	const cartData = webshop.getCartData();

	//back button
	function goBack() {
		router.back();
	}

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});

		gtm.viewCart();
	}

	//gtm
	function removeProduct(value) {
		if(value) {
			gtm.removeProduct(value);
		}
	}
	function updateProduct(value) {
		if(value) {
			gtm.updateProduct(value);
		}
	}
</script>

<style lang="less" scoped>
	main { display: flex; padding: 25px 0; }
	.w-row{
		padding-bottom: 70px;

		@media (max-width: @l){padding-bottom: 50px;}
	}
	.cart {
		margin-bottom: 18px; font-size: 15px;
		@media (max-width: @m) { font-size: 14px; }
	}
	.cart-title {
		background: @blue; color: #fff; padding: 15px 25px; font-size: 15px;
		@media (max-width: @m) { padding: 12px 17px; font-size: 13px; }
	}
	.page-title {
		font-size: 30px; padding-bottom: 25px; padding-top: 10px; font-weight: bold;
		@media (max-width: @m) { font-size: 18px; padding-bottom: 15px; }
	}
	.cart-parcel {
		position: relative; padding-left: 28px; margin-left: 10px; font-size: 15px;
		&:before { .icon-shopping-bag(); font: 21px/1 @fonti; color: #fff; position: absolute; top: -1px; left: 0; }
		@media (max-width: @m) {
			padding-left: 25px; margin-left: 7px; font-size: 13px;
			&:before { font-size: 18px; }
		}
	}
	.continue-shopping {
		font-weight: bold; text-decoration: none; position: relative; font-size: 15px; cursor: pointer; color: @blue;
		&:before{.icon-arrow-down(); font: 10px/1 @fonti; .rotate(90deg); display: inline-block; position: relative; top: -1px; margin-right: 8px; .transition(transform);}

		&:hover:before{transform: translateX(-5px) rotate(90deg);}
	}
	.counter {
		font-size: 21px; color: @green;
		@media (max-width: @m) { font-size: 18px; }
	}

	.related-title{
		font-size: 25px; font-weight: bold; padding-bottom: 25px;

		@media (max-width: @m){font-size: 20px; line-height: 1.2;}
	}
	.cart-sl-items{
		max-width: 1010px; position: relative;
		::-webkit-scrollbar{display: none;}
		::-webkit-scrollbar-thumb{display: none;}

		@media (max-width: @m){
			width: calc(~'100% - -40px');
			margin: 0 0 0 -20px;
		}
		@media (max-width: @ms) {
			width: calc(~'100% - -30px');
			margin: 0 0 0 -15px;
		}
	}
	.splide__slide{display: flex;}
</style>

<style lang="less">
	/*
	.cart-sl-items{
		.splide__arrows{position: absolute; top: 0; left: 0; right: 0;}
		.splide__arrow{
			position: absolute; top: 130px; left: -60px;

			@media (max-width: @t){left: -30px;}
		}
		.splide__arrow--next{
			left: auto; right: -60px;

			@media (max-width: @t){right: -30px;}
		}

		@media (max-width: @m) {
			.splide__list {
				display: flex !important;
				padding: 0 0 0 20px !important;
				overflow-y: hidden;
				white-space: normal;
				position: relative;
				&::-webkit-scrollbar {
					display: none;
				}
				&::-webkit-scrollbar-thumb {
					display: none;
				}
			}
			.splide__slide {
				flex-shrink: unset;
				min-width: 30%;
				width: 30%;
				margin-right: 20px;
				white-space: normal;
			}
		}
		@media (max-width: @ms) {
			.splide__list {
				padding: 0 0 0 15px !important;
			}
			.splide__slide {
				min-width: 55%;
				width: 55%;
			}
		}
	}
	*/
</style>
